import { ApiTypes, UITypes } from "types"

import { AlertRuleStatusCell } from "pages/contractor/MonitoringPage/AlertRuleStatusCell"

export interface TemperatureRuleThermostat {
  id: number
  email: string
  thermostatSn: string
  isActive: boolean
}

export const mapDevicesToTemperatureRuleThermostats = (
  devices?: ApiTypes.Model.Device[],
): TemperatureRuleThermostat[] =>
  (devices || []).map(device => ({
    id: device.id,
    email: device.email,
    thermostatSn: device.sn,
    isActive: device.work_status === "online",
  }))

export const mapTemperatureRuleThermostatsToRows = (thermostats: TemperatureRuleThermostat[]): UITypes.TableBodyRow[] =>
  thermostats.map(thermostat => ({
    checkbox: {},
    email: { value: thermostat.email },
    thermostat_sn: { value: thermostat.thermostatSn },
    status: { value: thermostat.isActive ? "active" : "inactive" },
    rowSettings: {
      id: thermostat.id,
      item: thermostat,
    },
  })) as UITypes.TableBodyRow[]

export const temperatureRuleThermostatHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    name: "checkbox",
    type: "checkbox",
    size: "mini",
    cellComponent: "checkbox",
  },
  {
    title: "Email",
    name: "email",
    size: "middle",
  },
  {
    title: "Thermostat S/N",
    name: "thermostat_sn",
    size: "small",
  },
  {
    title: "Status",
    name: "status",
    size: "small",
    cellComponent: AlertRuleStatusCell,
  },
]
